import { render, staticRenderFns } from "./CreateResourceModal.vue?vue&type=template&id=1802d818&scoped=true&"
import script from "./CreateResourceModal.vue?vue&type=script&lang=js&"
export * from "./CreateResourceModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1802d818",
  null
  
)

export default component.exports